module.exports = "/_next/static/images/illustration-9c9768ba305e1e8e48b7c2c0c7ed2dbb.svg";